import React from 'react';
import CardContent from '@mui/material/CardContent';
import measurementsIcon from '#component/icon/measurements';
import {
  StyledCard,
  CardHeader,
  CardHeaderText,
  CardIdentifiers
} from '#component/device/overview/styles';

function MeasurementCard(props) {
  const {
    identifier,
    device,
    index,
    handleOpen,
    presentMeasurements
  } = props;

  const isPresent = presentMeasurements.some(obj => obj.identifier === identifier);
  const { value, unit } = isPresent ?
    presentMeasurements.find(obj => obj.identifier === identifier) : {};

  const icon = measurementsIcon(identifier, device, value);

  return (
    isPresent &&
    <StyledCard>
      <CardContent
        onClick={() => handleOpen(index)}
        component={CardHeader}
      >
        <CardIdentifiers>
          {icon}
          {identifier.toUpperCase()}
        </CardIdentifiers>
        <CardHeaderText>
          {value}
          {unit}
        </CardHeaderText>
      </CardContent>
    </StyledCard>
  );
}

export default MeasurementCard;
